angular.module('TetherApp').controller('ListenerExperienceController', [
    '$window',
    '$location',
    '$anchorScroll',
    'listenerExperienceService',
    '$scope',
    function (
        $window,
        $location,
        $anchorScroll,
        listenerExperienceService,
        $scope
    ) {
        let self = this;
        self.listenerExperiencesLooped = [];

        self.init = function (experiences) {
            self.experiences = experiences;
            if(window.listenerExperiencesLooped != undefined) {
                angular.forEach(window.listenerExperiencesLooped, function( value, key ) {
                    self.listenerExperiencesLooped.push(value);
                }, self);
            }
        };

        self.refresh = function(){
            // console.log(self.listenerExperiencesLooped);
        };

        self.updateNewListenerExperienceLooped = function() {
            angular.forEach(self.experiences, function( value, key ) {
                if(value.id == self.listenerExperienceLoopedSelected) {
                    self.listenerExperienceLoopedSelectedName = value.name
                }
            }, self);
        }

        self.createListenerExperienceLooped = function () {
            data = {};

            data.id = null;
            data.experience_id = self.listenerExperienceLoopedSelected;
            data.name = self.listenerExperienceLoopedSelectedName;

            if(!data.experience_id) {
                self.hasError = 1;
            } else {
                self.hasError = 0;

                self.listenerExperiencesLooped.push(
                    data
                );

                self.listenerExperienceLoopedSelected = null;
                self.listenerExperienceLoopedSelectedName = null;
            }
        };

        self.deleteListenerExperienceLooped = function(key) {
            self.listenerExperiencesLooped.splice(key, 1);
        };

        $scope.$on('bag-one.drop-model', function (e, el) {
            self.refresh();
            //e.parent
            //console.dir(e);
            //console.dir(el);
        })

    }
]);
